const PurposeEnum = Object.freeze({
  ADVICE: 'adviceLighting',
  DEVELOPMENT: 'developmentLightplan',
});
export default {
  data() {
    return {
      PURPOSES: PurposeEnum
    };
  },

  computed: {
    purposes() {
      return Object.keys(PurposeEnum)
        .map((key) => {
          return {
            id: key,
            value: this.$t(`purposes.${PurposeEnum[key]}`),
            subscript: this.$t(`purposes.${PurposeEnum[key]}-subscript`)
          };
        });
    }
  }
};
